module.exports = __webpack_public_path__ + "img/Prime_logo_channel_b_m.028d3aa8.svg";